import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { colors, sizes, media } from 'styles/variables';

const OuterWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: ${colors.background[0]};
	z-index: 999999;
`;
const InnerWrapper = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width:100%;
	max-width:600px;
	padding:${sizes[3]};
	h2 {
		display: block;
		text-align: center;
		font-size: 3rem;
		color: ${colors.teal.base};
		margin-bottom: ${sizes[2]};
	}
	ul {
		display: grid;
		${media.notsmall}{
		grid-template-columns: repeat(2, 1fr);}
		// padding: 0 ${sizes[4]};
	}
	li {
		font-size: 0.9rem;
		background-image: url(/radio_0.svg);
		&.--active {
			background-image: url(/radio_1.svg);
		}
		background-repeat: no-repeat;
		background-position: left 8px;
		background-size: 16px;
		padding: 4px;
		padding-left: 24px;
		text-align: left;
		color:${colors.foreground[2]};
	}
`;

const Progress = styled.div`
	position: relative;
	width: 100%;
	height: ${sizes[0]};
	border-radius: 10px;
	background: ${colors.background[2]};
	margin-bottom: ${sizes[2]};
	overflow: hidden;
	div {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		background: ${colors.teal.base};
	}
`;

export default props => {
	const lang = props.pageContext.lang || '';
	const [loader] = useState(require(`data/${lang}_loader`));
	const [load, setLoad] = useState(0);
	const maxLoad = loader.length;

	useEffect(() => {
		function getRandom(min, max) {
			return Math.random() * (max - min) + min;
		}
		const interval = setInterval(() => {
			setLoad(load => load + getRandom(0.0025, 0.5));
		}, 50);
		return () => {
			clearInterval(interval);
		};
	}, []);

	if (load < maxLoad) {
		return (
			<OuterWrapper>
				<InnerWrapper>
					<h2>{Math.round((load / maxLoad) * 100)}%</h2>
					<Progress>
						<div style={{ width: `${(load / maxLoad) * 100}%` }} />
					</Progress>
					<ul>
						{loader.map((item, index) => (
							<li className={index < load ? '--active' : '--inactive'} key={index}>
								{item.item}
							</li>
						))}
					</ul>
				</InnerWrapper>
				<div dangerouslySetInnerHTML={{ __html: `<style>body{overflow:hidden;}</style>` }} />
			</OuterWrapper>
		);
	} else {
		return <></>;
	}
};
